import React from 'react';
import styled from 'styled-components';
import { Section, Container } from '../layout';
import { Title, Header, Paragraph } from '../typography';
import { Button } from '../ui';
import { VideoBackground } from '../media';
import { FadeIn } from '../animations';

interface HeroVideoSectionProps {
    videoSrc: string;
    posterImage?: string;
    title: string;
    header: string;
    headerHighlight?: string;
    paragraph: string;
    buttonText: string;
    buttonHref?: string;
    buttonOnClick?: () => void;
}

const ContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const HeroContent = styled.div`
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
    max-width: 900px;
    width: 100%;
`;

const ButtonWrapper = styled.div`
    margin-top: ${({ theme }) => theme.spacing.xl};
`;

export const HeroVideoSection: React.FC<HeroVideoSectionProps> = ({
    videoSrc,
    posterImage,
    title,
    header,
    headerHighlight,
    paragraph,
    buttonText,
    buttonHref,
    buttonOnClick,
}) => {
    return (
        <Section fullHeight maxHeightMobile="80vh">
            <VideoBackground videoSrc={videoSrc} posterImage={posterImage}>
                <Container>
                    <ContentWrapper>
                        <HeroContent>
                            <FadeIn delay={0}>
                                <Title>{title}</Title>
                            </FadeIn>
                            <FadeIn delay={200}>
                                <Header highlightText={headerHighlight}>{header}</Header>
                            </FadeIn>
                            <FadeIn delay={400}>
                                <Paragraph>{paragraph}</Paragraph>
                            </FadeIn>
                            <FadeIn delay={600}>
                                <ButtonWrapper>
                                    <Button
                                        text={buttonText}
                                        href={buttonHref}
                                        onClick={buttonOnClick}
                                    />
                                </ButtonWrapper>
                            </FadeIn>
                        </HeroContent>
                    </ContentWrapper>
                </Container>
            </VideoBackground>
        </Section>
    );
};
